var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSubInput = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 2,
  height: 16,
  fill: "none",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#DCDFE0",
  d: "M1 0v16"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgSubInput);
export default ForwardRef;